import { useContext } from 'react';
import { AppDataContextUpdate } from '@/contexts/app.context';

export function useAppDataContextUpdate() {
  return useContext(AppDataContextUpdate);
}
